<template>
    <PatientCoverage :Type="AppServiceID"></PatientCoverage>
</template>
<script>
import Vue from 'vue';
import PatientCoverage from '@/components/DPEBB/Administrator/PatientCoverages.vue';
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {
    data: function(){
        return {
        AppServiceID :1,
        }
    },
    components: { 
        PatientCoverage, 
    },
created: function() { 
    this.$emit('update:layout', LayoutDefault);
    this.AppServiceID = this.$store.getters.GetDentalID;
},    
beforeCreate: function() {
    this.$store.dispatch('AddServiceID',this.$store.getters.GetDentalID);
    this.$store.dispatch('GetMenuItems',this.$store.getters.GetDentalID);
},
}
</script>

<style>

</style>
